import axios from 'axios';

import { useServicerStore } from '../store';

const BillPaymentService = {
  async getBillPayments({ page, limit }) {
    const response = await axios.get('/bill_payment', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getBillPayment(billPaymentId) {
    const response = await axios.get(`/bill_payment/${billPaymentId}`);

    return response.data;
  },

  async createBillPayment(formValues) {
    const response = await axios.post('/bill_payment', {
      ...formValues,
      servicer_id: useServicerStore.getState()?.servicerId,
    });

    return response.data;
  },

  async updateBillPayment({ billPaymentId, formValues }) {
    const response = await axios.put(
      `/bill_payment/${billPaymentId}`,
      formValues
    );

    return response.data;
  },

  async applyBillPayment({ billPaymentId, billLineItemIds }) {
    const response = await axios.post(`/bill_payment/${billPaymentId}/apply`, {
      bill_line_item_ids: billLineItemIds,
    });

    return response.data;
  },

  async deleteBillPayment(billPaymentId) {
    const response = await axios.delete(`/bill_payment/${billPaymentId}`);

    return response.data;
  },

  async reverseBillPayment(billPaymentId) {
    const response = await axios.patch(
      `/bill_payment/${billPaymentId}/reverse`
    );

    return response.data;
  },

  async payNow(billPaymentId) {
    const response = await axios.post(`/bill_payment/${billPaymentId}/pay_now`);

    return response.data;
  },

  async cancelBillComPayment(billPaymentId) {
    const response = await axios.post(
      `/bill_payment/${billPaymentId}/billcom_cancel`
    );

    return response.data;
  },

  async voidBillComPayment(billPaymentId) {
    const response = await axios.post(
      `/bill_payment/${billPaymentId}/billcom_void`
    );

    return response.data;
  },
};

export default BillPaymentService;
